import IndexBg from "./IndexBg.js";

export default IndexBg;